import Seo from "@/components/Seo";
import { Eyebrow, Section, StatusChip } from "@/components/Type";
import { PRODUCTS } from "@/content/products";

export default function ProductsPage() {
  return (
    <>
      <Seo
        title="Products | W8ED"
        description="W8ED products translate science into something people can actually use — every day."
        path="/products"
      />
      <section className="px-6 pb-20 pt-32 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <Eyebrow>Products</Eyebrow>
          <h1 className="mt-8 max-w-4xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
            SCIENCE SHOULD BECOME PRACTICAL.
          </h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#8e8a80]">
            Research matters. But what matters just as much is what happens when that knowledge
            becomes something people can actually use every day. Products are a core part of the
            W8ED ecosystem — the point where science becomes a repeated behaviour.
          </p>
          <p className="mt-8 font-mono text-[10px] tracking-[0.25em] leading-loose text-[#57534a]">
            SCIENCE <span className="text-[#C9A227]">→</span> FORMULATION{" "}
            <span className="text-[#C9A227]">→</span> PRODUCT <span className="text-[#C9A227]">→</span>{" "}
            BEHAVIOUR <span className="text-[#C9A227]">→</span> REPEAT{" "}
            <span className="text-[#C9A227]">→</span> ADAPTATION
          </p>
          <p className="mt-6 font-mono text-[10px] tracking-[0.25em] text-[#C9A227]">
            YOU ARE WHAT YOU REPEAT.
          </p>
        </div>
      </section>

      <Section className="py-0 sm:py-0">
        <div className="grid gap-px border border-[#1f1e1a] bg-[#1f1e1a] sm:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.map((p) => (
            <article key={p.id} id={p.id} className="scroll-mt-24 bg-[#0a0a09] p-8 sm:p-10" data-testid={`product-${p.id}`}>
              <StatusChip status={p.status} />
              <h2 className="mt-5 font-display text-xl font-bold tracking-wide text-[#f5f2ea]">
                {p.name}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-[#8e8a80]">{p.line}</p>
            </article>
          ))}
        </div>
        <p className="mt-10 max-w-2xl font-mono text-[10px] leading-relaxed tracking-[0.15em] text-[#57534a]">
          PRODUCT PHOTOGRAPHY, INGREDIENTS, NUTRITION FACTS, SCIENTIFIC RATIONALE, USAGE, REFERENCES,
          REVIEWS AND PURCHASE WILL APPEAR HERE AS PRODUCTS BECOME REAL. NOTHING ON THIS PAGE IS FOR
          SALE YET.
        </p>
      </Section>
      <div className="py-16" />
    </>
  );
}
